import { BrowserRouter as Router, Routes } from "react-router-dom";
import { appRoutes } from "./routes.js";

function App() {
  return (
    <Router future={{ v7_startTransition: true }}>
      <Routes>{appRoutes}</Routes>
    </Router>
  );
}

export default App;
